import _debounce from "lodash/debounce";
import { fetchTimeout, deepCopy, RehydrateThumbnails, deleteCookie } from "../components/Common";
import { API_BASE, PRICEFILE_KEY } from "../AppConfig";
import { createStoreDatabase, decryptData } from "./database";
import { NEW_JOB } from "./jobState";
import { loadOffering } from "./configState";
import * as JOBSTATE_VALIDATION from "./jobState_Validation";

// App Actions
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_BUSINESS = "UPDATE_BUSINESS";

// Page Actions
export const UPDATE_APP = "UPDATE_APP";
export const TOGGLE_APP = "TOGGLE_APP";
export const UPDATE_PAGE = "UPDATE_PAGE";
// Page Attributes
export const MAIN_PAGE = "MAIN_PAGE";
export const DESIGNER_PAGE = "DESIGNER_PAGE";

// Designer Actions
export const UPDATE_DESIGNER = "UPDATE_DESIGNER";
export const TOGGLE_DESIGNER = "TOGGLE_DESIGNER";
export const SET_TOOLSET_AREA = "setToolSetArea";
export const SHOW_LOADING_BACKDROP = "SHOW_LOADING_BACKDROP";
export const LOADING_BACKDROP_MESSAGE = "LOADING_BACKDROP_MESSAGE";
// Designer Attributes
export const MAIN_DRAWER_OPEN = "mainDrawerOpen";
export const TOOL_DRAWER_OPEN = "toolDrawerOpen";
export const TOOL_DRAWER_HIDE = "toolDrawerHide";
export const TOOL_DRAWER_AREA = "toolDrawerArea";
export const THREED_MODE = "threeDMode";
export const THREED_MINI_MODE = "threeDMiniMode";
export const THREED_MINI_WIDTH = "threeDMiniWidth";
export const THREED_MINI_HEIGHT = "threeDMiniHeight";
export const SHOW_CUSTOMER_JOB_PANEL = "showCustomerJobPanel";
export const LOAD_WIND_DATA = "loadWindData";
export const SHOW_NOTES_PANEL = "showNotesPanel";
export const SHOW_DEBUG_TOOLS = "SHOW_DEBUG_TOOLS";
export const UNLOCKED = "UNLOCKED";
export const TOOL_DRAWER_WIDTH = "TOOL_DRAWER_WIDTH";

// 2D Designer Actions
export const UPDATE_2D_DESIGNER = "UPDATE_2D_DESIGNER";
export const UPDATE_2D_DESIGNER_SVGS = "UPDATE_2D_DESIGNER_SVGS";
export const TOGGLE_2D_DESIGNER = "TOGGLE_2D_DESIGNER";
export const SHOW_DESIGNER_MESSAGE = "SHOW_DESIGNER_MESSAGE";
export const CLEAR_DESIGNER_MESSAGE = "CLEAR_DESIGNER_MESSAGE";
export const CLEAR_ALL_DESIGNER_MESSAGE = "CLEAR_ALL_DESIGNER_MESSAGE";
export const APPEND_DESIGNER_MESSAGE = "APPEND_DESIGNER_MESSAGE";

export const SELECT_POINT = "SELECT_POINT";
export const SELECT_POINT_NOTE = "SELECT_POINT_NOTE";
export const SELECTED_POINT = "SELECTED_POINT";
export const UPDATE_EXISTING_SELECTED_POINT = "UPDATE_EXISTING_SELECTED_POINT";
export const SELECT_POINT_ALLOW_HIT_SELTYPE = "SELECT_POINT_ALLOW_HIT_SELTYPE";
export const AREA_INDEX = "AREA_INDEX";

// 2D Designer Attributes
export const SHOW_IMPORTED_MAP = "showImportedMap";
export const SHOW_BEAM_LENGTHS = "SHOW_BEAM_LENGTHS";
export const SHOW_POST_DIMENSIONS = "SHOW_POST_DIMENSIONS";
export const DRAW_FULL_LAYOUT = "DRAW_FULL_LAYOUT";

// 3D Designer Actions
export const UPDATE_3D_DESIGNER = "UPDATE_3D_DESIGNER";
export const TOGGLE_3D_DESIGNER = "TOGGLE_3D_DESIGNER";
export const UPDATE_3D_MODEL = "UPDATE_3D_MODEL";

// 3D Babylon Designer Attributes
export const SHOW_GROUND_PHOTO = "showGroundPhoto";
export const SHOW_HOUSE_MODEL = "showHouseModel";
export const SHOW_VERANDAH_MODEL = "showVerandahModel";
export const SHOW_VERANDAH_LAYOUT = "showVerandahLayout";
export const BABYLON_SELECTED_ITEM = "babylonSelectedItem";

export const ATTACHMENT_MESH_MODE = "ATTACHMENT_MESH_MODE";
export const ROOFSHEET__MESH_MODE = "ROOFSHEET__MESH_MODE";
export const BEAM_AND_POST_MESH_MODE = "BEAM_AND_POST_MESH_MODE";
export const GUTTERS_AND_FLASHING_MESH_MODE = "GUTTERS_AND_FLASHING_MESH_MODE";
export const FOOTINGS_MESH_MODE = "FOOTINGS_MESH_MODE";

export const VERANDAH_MESH_MODE = "verandahMeshMode";
export const VERANDAH_EDGE_LINE_MODE = "verandahEdgeLineMode";
export const BACKGROUND_MODE = "backgroundMode";
export const BACKGROUND_SHADOW_MODE = "backgroundShadowMode";
export const RENDERQUALITYFACTOR = "RENDERQUALITYFACTOR";
export const SUN_ANGLE = "SUN_ANGLE";
export const SUN_ANGLE_Y = "SUN_ANGLE_Y";
export const FONT_SIZE = "FONT_SIZE";
export const SHOW_GRAPH_BG = "SHOW_GRAPH_BG";
export const SHOW_DISPLAY_OPTIONS = "SHOW_DISPLAY_OPTIONS";

export const DRAWER_TOOLSET_EXPANDED = "drawerToolSetExpanded";

export const ATTACHMENT_TOOL = "attachment_tool";
export const GUTTERS_DOWNPIPES_TOOL = "gutters_downpipes_tool";
export const ROOFSHEET_TOOL = "roofsheet_tool";
export const BEAMS_AND_POSTS_TOOL = "beams_and_posts_tool";
export const PITCHED_GABLE_TOOL = "pitched_gable_tool";
export const OTHER_TOOLS = "OTHER_TOOLS";

export const SHAPE_TOOL = "SHAPE_TOOL";
export const SHOW_LOADING_BAR = "SHOW_LOADING_BAR";
export const SHOW_WIND_DATA_LOADING_BAR = "SHOW_WIND_DATA_LOADING_BAR";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const MESSAGE = "MESSAGE";
export const SHOW_DIALOG = "SHOW_DIALOG";
export const DIALOG_DATA = "DIALOG_DATA";
export const DOCUMENT_TO_SHOW = "DOCUMENT_TO_SHOW";
export const GENERATING_DOCUMENT = "GENERATING_DOCUMENT";
export const GENERATING_DOCUMENT_STATUS = "GENERATING_DOCUMENT_STATUS";
export const CUSTOM_COMPONENT_LIST_IS_OPEN = "CUSTOM_COMPONENT_LIST_IS_OPEN";

export const initialState = {
    page: MAIN_PAGE,
    MAIN_PAGE: {
        page: "Recall",
        NumRecallItems: 50,
    },
    help_open: false,
    help_section: null,
    designer: {
        [TOOL_DRAWER_OPEN]: false,
        [TOOL_DRAWER_HIDE]: false,
        [MAIN_DRAWER_OPEN]: false,
        [TOOL_DRAWER_AREA]: 0,
        [THREED_MODE]: false,
        [THREED_MINI_MODE]: false,
        [THREED_MINI_HEIGHT]: window.innerHeight * 0.45,
        [THREED_MINI_WIDTH]: window.innerWidth * 0.55,
        [SHOW_CUSTOMER_JOB_PANEL]: false,
        [SHOW_NOTES_PANEL]: false,
        [SHOW_LOADING_BAR]: true,
        [SHOW_LOADING_BACKDROP]: false,
        [SHOW_DEBUG_TOOLS]: false,
        [LOADING_BACKDROP_MESSAGE]: "",
        [SHOW_DIALOG]: false,
        [DIALOG_DATA]: {},
        [SHOW_MESSAGE]: false,
        [DOCUMENT_TO_SHOW]: null,
        [GENERATING_DOCUMENT]: false,
        [GENERATING_DOCUMENT_STATUS]: false,
        [MESSAGE]: "",
        [SHOW_DISPLAY_OPTIONS]: false,
        [UNLOCKED]: false,
        [TOOL_DRAWER_WIDTH]: 390,
        designer2D: {
            [SHOW_IMPORTED_MAP]: false,
            [SHOW_BEAM_LENGTHS]: false,
            [SHOW_POST_DIMENSIONS]: false,
            [DRAW_FULL_LAYOUT]: false,
            [FONT_SIZE]: 100,
            [SHOW_GRAPH_BG]: true,
            [SELECT_POINT_NOTE]: "",
            [AREA_INDEX]: -1,
            [SELECT_POINT]: false,
            [SELECT_POINT_ALLOW_HIT_SELTYPE]: false,
            [SELECTED_POINT]: { x: 0, y: 0 },
            svgs: {
                area_all: null,
            },
        },
        designer3D: {
            [SHOW_GROUND_PHOTO]: true,
            [SHOW_HOUSE_MODEL]: true,
            [SHOW_VERANDAH_MODEL]: false,
            [ATTACHMENT_MESH_MODE]: "Render",
            [ROOFSHEET__MESH_MODE]: "Render",
            [BEAM_AND_POST_MESH_MODE]: "Render",
            [GUTTERS_AND_FLASHING_MESH_MODE]: "Render",
            [FOOTINGS_MESH_MODE]: "Render",
            [VERANDAH_MESH_MODE]: false,
            [VERANDAH_EDGE_LINE_MODE]: false,
            [SHOW_VERANDAH_LAYOUT]: false,
            [BABYLON_SELECTED_ITEM]: null,
            [DRAWER_TOOLSET_EXPANDED]: null,
            [BACKGROUND_SHADOW_MODE]: false,
            [BACKGROUND_SHADOW_MODE]: false,
            [BACKGROUND_MODE]: "Grid",
            [RENDERQUALITYFACTOR]: 7,
            [SUN_ANGLE]: 1,
            [SUN_ANGLE_Y]: -1,
            objs: {
                area_all: null,
            },
        },
    },
    priceRise: null,
    user: null,
    logged_user_code: null,
    offerings: null,
    online: true,
    manufacturer: window?.F
        ? {
              Name: "Centenary",
              ProductName: "Centenary",
              FullRegisteredName: "Fielders Pty Ltd",
              Logo: "/app/images/centenary_logo.png",
              BrandColour: "rgb(0, 52, 102)",
              SoftwareName: "Centenary Design Suite",
          }
        : {
              Name: "Lysaght",
              ProductName: "Lysaght Living",
              FullRegisteredName: "Bluescope Steel Limited",
              Logo: "/images/lys_logo_topbar.png",
              BrandColour: "#066CB6",
              SoftwareName: "Lysaght Living Designer",
          },
    job_history_buffer: {
        data: [],
        pointer: -1,
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_APP:
            return {
                ...state,
                [action.parameter]: action.value,
            };
        case TOGGLE_APP:
            let toggle_app_value =
                action.value || action.value === false ? action.value : !state[action.parameter] ? true : false;
            return {
                ...state,
                [action.parameter]: toggle_app_value,
            };
        case UPDATE_PAGE:
            return {
                ...state,
                page: action.value,
            };
        case UPDATE_USER:
            return {
                ...state,
                user: action.value,
            };
        case UPDATE_BUSINESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    BusinessCode: action?.value?.id,
                    BusinessDetails: action.value,
                },
            };

        case UPDATE_DESIGNER:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [action.parameter]: action.value,
                },
            };

        case TOGGLE_DESIGNER:
            let value =
                action.value || action.value === false
                    ? action.value
                    : !state.designer[action.parameter]
                    ? true
                    : false;
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [action.parameter]: value,
                },
            };
        case UPDATE_2D_DESIGNER:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer2D: {
                        ...state.designer.designer2D,
                        [action.parameter]: action.value,
                    },
                },
            };
        case UPDATE_2D_DESIGNER_SVGS:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer2D: {
                        ...state.designer.designer2D,
                        svgs: {
                            ...state.designer.designer2D.svgs,
                            [action.parameter]: action.value,
                        },
                    },
                },
            };
        case UPDATE_3D_MODEL:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer3D: {
                        ...state.designer.designer3D,
                        objs: {
                            ...state.designer.designer3D.objs,
                            [action.parameter]: action.value,
                        },
                    },
                },
            };
        case TOGGLE_2D_DESIGNER:
            let value_TOGGLE_2D_DESIGNER =
                action.value || action.value === false
                    ? action.value
                    : !state.designer.designer2D[action.parameter]
                    ? true
                    : false;

            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer2D: {
                        ...state.designer.designer2D,
                        [action.parameter]: value_TOGGLE_2D_DESIGNER,
                    },
                },
            };
        case UPDATE_3D_DESIGNER:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer3D: {
                        ...state.designer.designer3D,
                        [action.parameter]: action.value,
                    },
                },
            };
        case TOGGLE_3D_DESIGNER:
            let value_TOGGLE_3D_DESIGNER =
                action.value || action.value === false
                    ? action.value
                    : !state.designer.designer3D[action.parameter]
                    ? true
                    : false;

            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer3D: {
                        ...state.designer.designer3D,
                        [action.parameter]: value_TOGGLE_3D_DESIGNER,
                    },
                },
            };
        case SET_TOOLSET_AREA:
            let toolset = state.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
            if (action.toolset !== null) {
                toolset = action.toolset;
            }

            return {
                ...state,
                designer: {
                    ...state.designer,
                    [TOOL_DRAWER_AREA]: action.area,
                    designer3D: {
                        ...state.designer.designer3D,
                        [DRAWER_TOOLSET_EXPANDED]: toolset,
                    },
                },
            };

        case SHOW_DESIGNER_MESSAGE: {
            const currentMessages = state.designer[MESSAGE] || [];
            const newMessage = action.message;

            const isDuplicate = currentMessages.some((m) => JSON.stringify(m) === JSON.stringify(newMessage));

            if (isDuplicate) {
                return state;
            }

            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: true,
                    [MESSAGE]: [...currentMessages, newMessage],
                },
            };
        }

        case CLEAR_DESIGNER_MESSAGE: {
            const currentMessages = state.designer[MESSAGE] || [];
            let messageToRemove = [];
            if (Array.isArray(action.payload)) {
                messageToRemove = action.payload;
            } else if (action.payload?.message) {
                messageToRemove = [action.payload.message];
            }

            const updatedMessages = currentMessages.filter((msg) => {
                // Direct reference match (works for React elements or primitive types)
                if (msg === messageToRemove) return false;

                // For structured objects (e.g., { message: "text" })
                if (typeof msg === "object" && msg !== null && "message" in msg) {
                    // return msg.message !== messageToRemove;
                    if (msg.id && messageToRemove.includes(msg.id)) {
                        return false;
                    }
                    return !messageToRemove.includes(msg.message);
                }

                return true;
            });

            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: updatedMessages.length > 0,
                    [MESSAGE]: updatedMessages,
                },
            };
        }

        case CLEAR_ALL_DESIGNER_MESSAGE:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: false,
                    [MESSAGE]: [],
                },
            };

        case APPEND_DESIGNER_MESSAGE:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: true,
                    [MESSAGE]: (state.designer.message ? state.designer.message + "<br />" : "") + action.message,
                },
            };
        case SHOW_DIALOG:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_DIALOG]: true,
                    [DIALOG_DATA]: action.value,
                },
            };

        default:
            return state;
    }
}

export const showDialog =
    (title, message, primaryActionText = "Close", primaryAction, secondaryActionText, secondaryAction) =>
    (dispatch) => {
        dispatch({
            type: SHOW_DIALOG,
            value: {
                title: title,
                message: message,
                primaryActionText: primaryActionText,
                primaryAction: primaryAction,
                secondaryActionText: secondaryActionText,
                secondaryAction: secondaryAction,
            },
        });
    };
export const showDialogData = (dialogData) => (dispatch) => {
    let defaultData = {
        title: "",
        message: "",
        primaryActionText: "OK",
        primaryAction: null,
        secondaryActionText: null,
        secondaryAction: null,
    };

    dispatch({
        type: SHOW_DIALOG,
        value: {
            ...defaultData,
            ...dialogData,
        },
    });
};

export const UNDO = () => (dispatch) => {
    dispatch({
        type: "UNDO",
    });
};
export const REDO = () => (dispatch) => {
    dispatch({
        type: "REDO",
    });
};

export const loadAppTemplate = (template) => (dispatch) => {
    dispatch({
        type: "LOAD_TEMPLATE",
        value: template,
    });
};

export const resetAll = () => (dispatch) => {
    dispatch({
        type: "RESET_ALL",
        value: "RESET_ALL",
    });
};

export const updateAPP = (parameter, value) => (dispatch) => {
    return new Promise((resolve) => {
        dispatch({
            type: UPDATE_APP,
            parameter: parameter,
            value: value,
        });
        return resolve(true);
    });
};

export const toggleAPP =
    (parameter, value = null) =>
    (dispatch) => {
        //
        return new Promise((resolve) => {
            dispatch({
                type: TOGGLE_APP,
                parameter: parameter,
                value: value,
            });
            return resolve(true);
        });
    };

export const resetDesigner = () => (dispatch, getState) => {
    const { job, app } = getState();
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const designerPreference = app?.user?.preferences?.designerMode;

    let threeDMode = false;
    let threeDMiniMode = false;

    if (!carportMode) {
        if (designerPreference === "Split") {
            threeDMode = true;
            threeDMiniMode = true;
        } else if (designerPreference === "Model View") {
            threeDMode = true;
        }
    }

    const currentDesigner3D = getState()?.app?.designer?.designer3D;

    dispatch({
        type: UPDATE_APP,
        parameter: "designer",
        value: {
            ...initialState.designer,
            designer2D: {
                ...getState()?.app?.designer?.designer2D,
                AREA_INDEX: -1,
                SELECT_POINT: false,
                SELECT_POINT_NOTE: null,
                SELECTED_POINT: null,
            },
            threeDMode,
            threeDMiniMode,
            designer3D: { ...currentDesigner3D },
        },
    });

    return Promise.resolve();
};

export const loadUser = (email_address, password) => (dispatch) => {
    return new Promise((resolve) => {
        dispatch(updateUserFromWeb(email_address, password)).then((user_data) => {
            if (!user_data) {
                return resolve(false);
            }
            if (user_data.Error) {
                return resolve(user_data);
            }

            dispatch({
                type: UPDATE_APP,
                parameter: "logged_user_code",
                value: email_address,
            });

            let config_url = API_BASE() + `config/` + btoa(email_address);

            if (!window.location.href.includes("use_cache")) {
                fetchTimeout(config_url, {
                    method: "GET",
                })
                    .then((res) => res.json())
                    .then(async (json_user_data) => {
                        if (!json_user_data?.offerings) throw "No offering data";

                        let offering = null;
                        if (window.FIELDERS && json_user_data?.offerings?.Fielders)
                            offering = json_user_data?.offerings?.Fielders;
                        if (window.LYSAGHT && json_user_data?.offerings?.Lysaght)
                            offering = json_user_data?.offerings?.Lysaght;

                        if (offering)
                            dispatch(updateAPP("offerings", json_user_data.offerings)).then(() => {
                                dispatch(loadOffering());
                            });
                        if (json_user_data?.pricefile) {
                            if (json_user_data?.pricefile?.Error)
                                dispatch({
                                    type: SHOW_DESIGNER_MESSAGE,
                                    message: json_user_data?.pricefile?.Error,
                                });
                            else {
                                const encryptedPricefile = json_user_data?.pricefile;

                                let decryptedPricefile;
                                // Decrypt the encrypted data
                                if (encryptedPricefile?.data && encryptedPricefile?.iv)
                                    decryptedPricefile = JSON.parse(
                                        decryptData(
                                            encryptedPricefile.data, // Access the "data" property that contains the encrypted data
                                            encryptedPricefile.iv,
                                            PRICEFILE_KEY // Encyrption Key
                                        )
                                    );

                                const encyrptedPricefile = json_user_data?.pricefile;

                                createStoreDatabase(JSON.stringify(encyrptedPricefile));
                                // dispatch(updateAPP("pricefile", RehydrateThumbnails(decryptedPricefile)));
                            }
                        } else {
                            // if pricefile not included in response.... fetch it
                            let d365_active = false;
                            if (window.LYSAGHT) {
                                d365_active =
                                    json_user_data?.offerings?.Lysaght?.Regions?.LSB?.region?.D365_State_Active;
                            } else {
                                d365_active =
                                    json_user_data?.offerings?.Fielders?.Regions?.MEN?.region?.D365_State_Active;
                            }
                            let config_url_pricefile =
                                API_BASE() + `config/` + btoa(email_address) + "?pf=true&d365_active=" + d365_active;

                            fetchTimeout(config_url_pricefile, {
                                method: "GET",
                            })
                                .then((res) => res.json())
                                .then(async (json_user_data) => {
                                    if (json_user_data?.pricefile?.Error)
                                        dispatch({
                                            type: SHOW_DESIGNER_MESSAGE,
                                            message: json_user_data?.pricefile?.Error,
                                        });
                                    else {
                                        const encryptedPricefile = json_user_data?.pricefile;

                                        let decryptedPricefile;
                                        // Decrypt the encrypted data
                                        if (encryptedPricefile?.data && encryptedPricefile?.iv)
                                            decryptedPricefile = JSON.parse(
                                                decryptData(
                                                    encryptedPricefile.data, // Access the "data" property that contains the encrypted data
                                                    encryptedPricefile.iv,
                                                    PRICEFILE_KEY // Encyrption Key
                                                )
                                            );

                                        const encyrptedPricefile = json_user_data?.pricefile;

                                        createStoreDatabase(JSON.stringify(encyrptedPricefile));
                                        // dispatch(updateAPP("pricefile", RehydrateThumbnails(decryptedPricefile)));
                                    }
                                })
                                .catch((e) => {
                                    resolve({
                                        Error: "Server Error: Could not load offerings from Server",
                                    });
                                });
                        }
                        if (json_user_data?.dist_level) dispatch(updateAPP("dist_levels", json_user_data?.dist_level));
                        if (json_user_data?.special_factors)
                            dispatch(updateAPP("special_factors", json_user_data?.special_factors));
                        if (json_user_data?.announcements)
                            dispatch(updateAPP("announcements", json_user_data?.announcements));
                        resolve(true);
                    })
                    .catch((e) => {
                        resolve({
                            Error: "Server Error: Could not load offerings from Server",
                        });
                    });
            }
        });
    });
};

export const changePage = (page_name) => (dispatch) => {
    window.history.pushState({ page: page_name }, page_name, window.location);
    dispatch({
        type: UPDATE_PAGE,
        value: page_name,
    });

    if (page_name === MAIN_PAGE)
        dispatch({
            type: NEW_JOB,
            parameter: null,
        });
};

export const changeMainPage =
    (page_name, record_state = true) =>
    (dispatch, getState) => {
        if (record_state) window.history.pushState({ MAIN_PAGE: { page: page_name } }, page_name, window.location);

        let new_state = { ...getState().app[MAIN_PAGE] };
        new_state.page = page_name;
        new_state._ts = Date.now();

        dispatch({
            type: UPDATE_APP,
            parameter: MAIN_PAGE,
            value: new_state,
        });
    };

export const SetAppDialogMessage = (message) => (dispatch, getState) => {
    let new_state = { ...getState().app[MAIN_PAGE] };
    new_state.Message = message;

    dispatch({
        type: UPDATE_APP,
        parameter: MAIN_PAGE,
        value: new_state,
    });
};

export const updateUserFromWeb =
    (email_ddress_id, password = null) =>
    (dispatch) => {
        checkInternetConnection(dispatch);

        return new Promise((resolve) => {
            fetchTimeout(API_BASE() + "user/" + btoa(email_ddress_id) + (password ? "/" + password : ""), {
                method: "GET",
            })
                .then(async (response) => {
                    if (response.status >= 200 && response.status <= 300) {
                        let user_data = await response.json();

                        dispatch(updateUser(user_data));
                        resolve(user_data);
                    } else if (response.status === 401) {
                        let error = await response.json();

                        resolve(error);
                        return;
                    } else resolve(false);
                })
                .then(async (response) => {
                    if (response.status >= 200 && response.status <= 300) {
                        let user_data = await response.json();

                        if (user_data?.BusinessDetails?.Brand && window.debug) {
                            window.brand = user_data?.BusinessDetails?.Brand;
                            if (window.brand === "Fielders") {
                                window.FIELDERS = true;
                                window.LYSAGHT = false;
                            } else if (window.brand === "Lysaght") {
                                window.FIELDERS = false;
                                window.LYSAGHT = true;
                            }
                        }
                        dispatch(updateUser(user_data));
                        resolve(user_data);
                    } else if (response.status === 401) {
                        let error = await response.json();

                        resolve(error);
                        return;
                    } else resolve(false);
                })
                .catch((e) => {
                    resolve({
                        Error: "Server Error: Could not load user from Server",
                    });
                });
        });
    };

export const updateAnnouncements = () => (dispatch) => {
    checkInternetConnection(dispatch);

    let api_url = API_BASE() + "admin/getannouncements/";
    if (window.LYSAGHT) api_url = API_BASE() + "admin/getannouncements/?b=L";
    fetchTimeout(api_url, {
        method: "GET",
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.Message) throw json.Message;
            dispatch(updateAPP("announcements", json));
        })
        .catch((e) => {});
};

export const updateUser = (user_data) => (dispatch, getState) => {
    checkInternetConnection(dispatch);

    dispatch({
        type: UPDATE_USER,
        value: user_data,
    });

    let job = getState().job;

    if (job) {
        let new_job = deepCopy(job);
        new_job = JOBSTATE_VALIDATION.validateFullJob(getState().config, new_job, -1, getState().app);

        dispatch({
            type: "NEW_JOB",
            parameter: new_job,
        });
    }
};

export const updateBusiness = (businessDetails) => (dispatch) => {
    dispatch({
        type: UPDATE_BUSINESS,
        value: businessDetails,
    });
};

export const saveUserToWeb =
    (user_data, update_local_data = false, update_business = false) =>
    (dispatch) => {
        checkInternetConnection(dispatch);

        if (update_local_data) dispatch(updateUser(user_data));

        let savejob_url = API_BASE() + "user/" + btoa(user_data.id);
        if (update_business) savejob_url += "/UpdateBusiness";

        return fetchTimeout(savejob_url, {
            method: "PUT",
            body: JSON.stringify(user_data),
        });
    };

export const updateDesigner = (parameter, value) => (dispatch) => {
    dispatch({
        type: UPDATE_DESIGNER,
        parameter: parameter,
        value: value,
    });
    return Promise.resolve();
};
export const toggleDesigner = (parameter) => (dispatch) => {
    dispatch({
        type: TOGGLE_DESIGNER,
        parameter: parameter,
    });
    return Promise.resolve();
};

export const setDesignerLoadingBackdrop = (message) => (dispatch) => {
    if (!message) {
        dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
        return Promise.resolve();
    }
    dispatch({
        type: UPDATE_DESIGNER,
        parameter: SHOW_LOADING_BACKDROP,
        value: true,
    });
    dispatch({
        type: UPDATE_DESIGNER,
        parameter: LOADING_BACKDROP_MESSAGE,
        value: message,
    });
    return Promise.resolve();
};

export const getImageBlob = function (url) {
    return new Promise(async (resolve) => {
        try {
            let resposne = await fetchTimeout(url, {
                method: "GET",
            });
            let blob = resposne.blob();
            resolve(blob);
        } catch (e) {
            resolve(false);
        }
    });
};

// convert a blob to base64
export const blobToBase64 = function (blob) {
    return new Promise((resolve) => {
        let reader = new FileReader();
        reader.onload = function () {
            let dataUrl = reader.result;
            resolve(dataUrl);
        };
        reader.readAsDataURL(blob);
    });
};

export const checkInternetConnection = (dispatch) => {
    if (window.OFFLINE_MODE) {
        if (!window.OFFLINE_SET) {
            window.OFFLINE_SET = true;

            dispatch({
                type: UPDATE_APP,
                parameter: "online",
                value: true,
            });
        }

        return;
    }

    if (document.hidden) return;

    var connected = window.navigator.onLine;

    if (connected) {
        if (window.checkingConnection > 0) {
            window.checkingConnection--;
            return;
        }

        window.checkingConnection = 3;

        fetchTimeout(
            API_BASE() + "isalive/ping",
            {
                method: "GET",
            },
            5000
        )
            .then(async (response) => {
                if (response.status >= 200 && response.status <= 300) {
                    connected = true;
                    window.checkingConnectionFailed = 0;
                    window.tokenexpired = 0;

                    dispatch({
                        type: UPDATE_APP,
                        parameter: "online",
                        value: true,
                    });

                    try {
                        let json = await response.json();
                        const hasServerHealth = json.hasOwnProperty("serverHealth");

                        dispatch({
                            type: UPDATE_APP,
                            parameter: "serverHealth",
                            value: hasServerHealth ? "alerting" : "OK",
                        });

                        window.settings = json;
                    } catch {}
                } else {
                    if ((response, response.status === 401)) {
                        let response_text = await response.text();

                        if (response_text.includes("TOKEN DENIED")) {
                            if (window.tokenexpired) {
                                window.tokenexpired++;
                            } else {
                                window.tokenexpired = 1;
                            }

                            if (window.tokenexpired >= 5) {
                                // logout and redirect to auth
                                deleteCookie("CDS_token");
                                localStorage.clear();

                                dispatch({
                                    type: "LOG_OUT",
                                });

                                localStorage.clear();

                                setTimeout(function () {
                                    localStorage.clear();
                                    window.location.href = "/auth/";
                                }, 1000);
                            }
                        }
                    }

                    throw false;
                }

                window.checkingConnection = false;
            })
            .catch((e) => {
                if (!window?.checkingConnectionFailed) window.checkingConnectionFailed = 0;
                window.checkingConnectionFailed++;
                window.checkingConnection = false;
                if (window.checkingConnectionFailed > 3) {
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                    dispatch({
                        type: UPDATE_APP,
                        parameter: "online",
                        value: false,
                    });
                    setTimeout(function () {
                        checkInternetConnection(dispatch);
                    }, 3000);
                } else {
                    setTimeout(function () {
                        checkInternetConnection(dispatch);
                    }, 2000);
                }
            });
    } else if (!connected) {
        dispatch({
            type: UPDATE_APP,
            parameter: "online",
            value: false,
        });
        dispatch({
            type: TOGGLE_DESIGNER,
            parameter: SHOW_LOADING_BAR,
            value: false,
        });
        dispatch({
            type: SHOW_DESIGNER_MESSAGE,
            message: "INTERNET NOT CONNECTED. Check your connection and try again.",
        });
        window.checkingConnection = false;
        setTimeout(function () {
            checkInternetConnection(dispatch);
        }, 1000);
    }

    return connected;
};

export const showDesignerMessage = (message) => (dispatch) => {
    dispatch({
        type: SHOW_DESIGNER_MESSAGE,
        message: message,
    });
};

export const update2DDesigner = (parameter, value) => (dispatch) => {
    dispatch({
        type: UPDATE_2D_DESIGNER,
        parameter: parameter,
        value: value,
    });
};
export const toggle2DDesigner = (parameter) => (dispatch) => {
    dispatch({
        type: TOGGLE_2D_DESIGNER,
        parameter: parameter,
    });
};

export const update3DDesigner = (parameter, value) => (dispatch) => {
    dispatch({
        type: UPDATE_3D_DESIGNER,
        parameter: parameter,
        value: value,
    });
};
export const toggle3DDesigner = (parameter) => (dispatch) => {
    dispatch({
        type: TOGGLE_3D_DESIGNER,
        parameter: parameter,
    });
};
